// utils/auth.js
import { jwtDecode } from "jwt-decode";
import API_ENDPOINTS from "../apiConfig";
import { reportServerVersion } from "./serverVersion";
import { clearAdminToken } from "./adminAuth";

export const getToken = () => localStorage.getItem("token");

export const getTokenDecoded = () => {
    const decoded = jwtDecode(getToken());

    return decoded;
}

export const isTokenExpired = (leewaySeconds = 10080) => {
    const token = getToken();
    if (!token) return true;

    try {
        const decoded = jwtDecode(token);
        const now = Date.now() / 1000;
        return decoded.exp < now + leewaySeconds; // will expire soon
    } catch {
        return true;
    }
};
// utils/auth.js
export const logout = async (navigate, resetContext) => {
    try {
        const token = localStorage.getItem("token");

        if (token) {
            await fetch(API_ENDPOINTS.RequestLogout, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
        }
        localStorage.removeItem("token");
        localStorage.removeItem("siteId");
        localStorage.removeItem("areaId");
        localStorage.removeItem("actualUserRole");
        clearAdminToken();

        resetContext?.();
        navigate("/");
    } catch (err) {
        console.error("Logout failed:", err);
        localStorage.removeItem("token");
        localStorage.removeItem("siteId");
        localStorage.removeItem("areaId");
        localStorage.removeItem("actualUserRole");
        clearAdminToken();
        resetContext?.();
        navigate("/");
    }
};

export const refreshToken = async () => {
    const token = getToken();
    if (!token) throw new Error("No token to refresh");

    const res = await fetch(API_ENDPOINTS.RefreshToken, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`, // send old token
            "Content-Type": "application/json",
        },
    });
    reportServerVersion(res);
    let tokenStillValid = false;
    if (!res.ok) {
        if (res.status == 400) {
            //still valid, do nothing
            console.info("token still valid");
            tokenStillValid = true;
        } else {
            //throw new Error("Failed to refresh token");
        }
    }
    if (!tokenStillValid) {
        const data = await res.json();
        localStorage.setItem("token", data.token); // overwrite old token
        console.log("token refreshed");
    }
    return res.status;
};
